import {useEffect, useState} from 'react';
import {createProductSelectionHandler} from '../domain/ProductSelection.model';
import {DealType} from '../domain/DealSelection.model';

const DEFAULT_QUANTITY = 1;

// Deals que ya llevan su propio lote (oferta de corta caducidad) o no admiten uno: el lote elegido a
// mano por el comercial solo acompaña a la compra normal o a una oferta por cantidad.
const admiteLoteManual = (selection) =>
  selection?.dealType !== DealType.LOT && selection?.dealType !== DealType.PROMO;

export const useProductSelection = (productDetails, defaultQuantity = DEFAULT_QUANTITY) => {
  const [quantity, setQuantity] = useState(defaultQuantity);
  const [dealSelection, setDealSelection] = useState(() => null);
  // Lote elegido a mano en la tabla de lotes de la ficha (comercial con permiso "Elegir lote"); null = automático
  const [manualLot, setManualLot] = useState(null);

  const buildProductSelection = createProductSelectionHandler(productDetails, quantity);

  const [productSelection, setProductSelection] = useState(() => buildProductSelection(productDetails, quantity));

  useEffect(() => {
    const selection = buildProductSelection(dealSelection, quantity);
    if (manualLot && admiteLoteManual(selection)) {
      selection.lotCode = manualLot;
    }
    setProductSelection(selection);
  }, [dealSelection, quantity, manualLot]);

  return { productSelection, dealSelection, setQuantity, setDealSelection, manualLot, setManualLot };
};
